var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content warehouse-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.Charge"),
        width: "1200px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
          ),
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("Pricing.Cancel")))
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c("tab-charges", {
            ref: "tabCharge",
            staticStyle: {
              "min-height": "600px",
              padding: "0",
              "min-width": "1180px"
            },
            attrs: {
              "charge-source": _vm.chargeSource,
              context: _vm.chargeDialog.context,
              action: _vm.chargeDialog.action
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }